module.exports = __webpack_public_path__ + "static/img/tab6.3b22bef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/tab6.png
// module id = VG3z
// module chunks = 0